<template>
    <div class="mt-4 d-flex flex-row align-items-center justify-content-center">
        <div class="card card-body shadow-sm" style="max-width: 30rem; width: 100%;">
            <div class="row">
                <div class="col-12">
                    <label>
                        {{ $t('scan.field.search_cart_code_label') }}
                    </label>
                    <input
                        type="text"
                        id="text"
                        v-model="code"
                        class="form-control"
                        :placeholder="$t('scan.field.cart_code_placeholder')"
                    />
                </div>
                <div class="col-12 mt-3">
                    <button class="btn btn-primary w-100" @click="onFound">
                        {{ $t('scan.buttons.search') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MerchantLayout from "../../../Layouts/MerchantLayout.vue";

export default {
    name: "Scan",
    layout: MerchantLayout,
    props: {
        errors: Object,
        error: String,
    },
    data() {
        return {
            code: null
        }
    },
    methods: {
        onFound() {
            window.location.href = "/merchant/transport/scan/"+ this.code;
        }
    },
}
</script>

<style scoped>
</style>
